import { DEFAULT_PREFERRED_CURRENCY } from '../../../utils/Money/constants';

import { fetchStorageValue } from '../../../hooks/useStorage';
import type { IUserOrgId } from '../../../types';
import { StorageKeys } from '../../../types';
import type { TravelerInfo } from '../../../types/api/v1/obt/common/traveler_info';

export const getTravelerInfoHeader = async (travelerPreferredCurrency: string): Promise<string> => {
  const preferredCurrency = (travelerPreferredCurrency ?? DEFAULT_PREFERRED_CURRENCY).toUpperCase();

  const primaryTravelerId = await fetchStorageValue<IUserOrgId>(StorageKeys.PRIMARY_TRAVELER_ID);
  const loggedInUserId = await fetchStorageValue<IUserOrgId>(StorageKeys.LOGGED_IN_USER_ID);

  const userOrgId = primaryTravelerId || loggedInUserId;

  const travelerInfo: TravelerInfo = {
    userOrgId,
    preferences: { preferredCurrency },
  };

  return JSON.stringify(travelerInfo);
};
